import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../api-routes";
import apiService from "../../services/service";

const initialState = {
  shareHolders: null,
  status: "idle",
  error: null,
};

export const fetchShareHolder = createAsyncThunk(
  "shareHolders/fetchShareHolder",
  async (id) => {
    return await apiService(API_ROUTES.SHARE_HOLDERS, "GET", {
      replace: { id },
    });
  },
);

export const updateShareHolder = createAsyncThunk(
  "shareHolders/updateShareHolder",
  async ({ id, data }) => {
    const url = API_ROUTES.UPDATE_SHAREHOLDER(id);

    const response = await apiService(url, "PUT", {
      body: JSON.stringify(data),
    });
    return response.data;
  },
);

const shareHoldersSlice = createSlice({
  name: "shareHolders",
  initialState,
  reducers: {
    resetShareHolders: (state) => {
      state.status = "idle";
      state.shareHolders = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchShareHolder.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchShareHolder.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.shareHolders = action.payload;
      })
      .addCase(fetchShareHolder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(updateShareHolder.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateShareHolder.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (state.shareHolders) {
          state.shareHolders = state.shareHolders.map((shareHolder) =>
            shareHolder.id === action.payload.id ? action.payload : shareHolder,
          );
        } else {
          state.shareHolders = [action.payload];
        }
      })
      .addCase(updateShareHolder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});
export const { resetShareHolders } = shareHoldersSlice.actions;
export default shareHoldersSlice.reducer;
